import { PaymentMethodType } from '@nemuru-eng/js-api-client';

export class NoConditionsAvailableException extends Error {
  constructor(paymentMethodType: PaymentMethodType) {
    super(`No conditions available for ${paymentMethodType} payment method`);
  }
}
